
<wms-dialog-header (onClose)="onClose()"   >

</wms-dialog-header>
<wms-dialog-body>
<wms-add-custom-icon-template [dialogeAction]="dialogeAction" (enableDialogeAction)="enableActions($event)"   ></wms-add-custom-icon-template>
</wms-dialog-body>
<wms-dialog-footer>
  <button class=" button-primary btn app-button" [disabled]="!(libName && cssFile && ttfFile)" (click)="save()">Save</button>
</wms-dialog-footer>
